import { render, staticRenderFns } from "./live-date.vue?vue&type=template&id=f5f0d85c&scoped=true&"
import script from "./live-date.vue?vue&type=script&lang=js&"
export * from "./live-date.vue?vue&type=script&lang=js&"
import style0 from "./live-date.vue?vue&type=style&index=0&id=f5f0d85c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f0d85c",
  null
  
)

export default component.exports